

const Bazo = ({...props}) => {
    return <g
            {...props}
            // bazo
        >
            <path
            d="M146.895 69.305l.38-.519.519-.346.553-.069.796.242 1.002.934.485 1.245-.104 1.002-.346.969-.553.691-.83.311-.692-.138-.657-.588-.138-.467.277-.674-.139-.899-.45-.553-.103-.484z"
            fill="#942914"
            fill-opacity=".743"
            stroke="#fc5000"
            stroke-width=".24"
            stroke-miterlimit="3.9"
            stroke-dasharray=".47922533,.23961266"
            />
            <path
            d="M246.762 75.597l2.351-3.235 3.207-2.157 3.421-.431 4.918 1.51 6.2 5.823 2.993 7.765-.641 6.255-2.138 6.039-3.421 4.314-5.131 1.94-4.276-.862-4.063-3.667-.855-2.911 1.71-4.206-.855-5.608-2.78-3.451-.64-3.02z"
            fill="#942914"
            fill-opacity=".743"
            stroke="#fc5000"
            stroke-width="1.488"
            stroke-miterlimit="3.9"
            stroke-dasharray="2.97600506,1.48800253"
            />
            <path
            d="M251.448 76.547l1.607-.382 2.268 1.621 1.513 1.812 1.323 2.384.472 2.574-.945 2.098 1.134 4.195.473 1.144-1.04 1.43-1.04 3.433-1.606 1.812-.85-1.24-.568.477-1.134-2.67 1.323-4.958-.85-8.677-1.985-1.048-.095-1.907-.945-.477v-1.24z"
            fill="#a04641"
            fill-opacity=".941"
            />
            <path
            d="M250.607 76.004l.522-.055.998-.116.465-1.014.585-.354.526.72.533 1.413 1.927 1.134 1.013.994.514 1.604.9 1.767.289 1.563-.6 2.455.325 3.304.998 1.735-.988 2.35-.217 2.674-2.329 2.754-.522.203-.522.202-.04-.243-.04-.243.763-1.053.763-1.053.2-1.58.201-1.58 1.697-2.301-1.295-4.1v-1.336l.654-1.397.014-1.802-1.117-2.102-1.157-.857-.563-1.336-2.329-1.702-1.282.345-1.047.951-.32-1.053z"
            fill="#701b17"
            fill-opacity=".996"
            />
            <path
            d="M257.514 71.467l-1.285.405-1.044.891.16 1.053 2.41.568s1.606 3.16 1.686 3.483c.08.325 1.526 1.783 1.526 1.783l2.249 1.377.883 2.593.08 3.321-.883 1.216-.642-.891-.482 2.187.562 2.836-.24 2.268-1.607 2.35-3.132 1.215-.884 2.35-1.686.972-.322.567 3.454.89 4.738-1.781 3.614-4.618 2.008-6.725.482-4.456-2.891-7.859-5.3-5.023-1.848-.891-1.606-.081zm4.223 3.463l1.377 1.19.099 1.588-.788-.099-1.082-.893-.59-1.29.984-.496z"
            fill="#a02c2c"
            fill-opacity=".766"
            />
            <path
            d="M250.574 79.311l.08 1.62.964 1.297 1.687 1.296-.402.649-1.285-.325v.892l.803.81.322 4.375.722 1.377.161 1.296-.803 1.864.321 1.944.884.73.24-1.783.964-1.053.964-3.403-.482-4.78-.24-2.998-1.286-2.916-1.445-.649-.643.81-.803-1.053-1.205-.162z"
            fill="#86302b"
            fill-opacity=".996"
            />
            <path
            d="M255.199 101.936l3.212.96 4.522-1.56 3.807-4.741 1.785-6.481.594-4.982-2.974-7.741-5.116-4.801-.357-.54-2.856-.54 2.083 1.08 1.19 1.56 1.546.84 2.499 2.7 1.249 4.502.119 3.6.178 1.14.12 3.182-1.666 6.3-2.142 2.882-.773 1.74-3.272.72-1.13.36s-1.547-.54-2.023-.42c-.476.12-.595.24-.595.24z"
            fill="#792b27"
            />
            <path
            d="M259.369 84.563l.624-.164.133.164-.025.477-.026.477-.176.433-.177.434-.115.673.267.064.186 1.135.015.86-.481-.178-.225-.473-.097-.825-.206-.78.264-.36-.062-.55-.101-.303-.101-.304.342-.343z"
            fill="#fffcf5"
            fill-opacity=".559"
            />
            <path
            d="M260.012 92.018l-.546.195-.129.486-.353.584-.032.68.546.292.514-.194.193-.616-.354-.454.065-.584.128-.13zM259.145 81.645l-.354-1.232-.514-.518-.032-.584-.386-.875-.61-.746-.193.292.546.519.097.68.514 1.005.064.487.578.648.129.454.321.421z"
            fill="#fffcf5"
            fill-opacity=".561"
            />
        </g>
}

export default Bazo